<template>
  <div class="my-account-password">
    <validation-observer ref="simpleRules">
      <b-card>
        <b-form @submit.prevent>
          <b-card class="border mb-0">
            <div class="d-flex align-items-center mb-2">
              <feather-icon
                icon="LockIcon"
                size="18"
                class="mr-50 text-primary"
              />
              <h5 class="mb-0">
                {{ $t('myAccount.tabs.changePassword') }}
              </h5>
            </div>

            <b-row>
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="$t('myAccount.fields.oldPassword')"
                  label-for="old-password"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('myAccount.fields.oldPassword')"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="old-password"
                        v-model="passwordValueOld"
                        name="old-password"
                        :type="passwordFieldTypeOld"
                        :placeholder="$t('myAccount.placeholders.oldPassword')"
                        :state="errors.length > 0 ? false : null"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIconOld"
                          class="cursor-pointer"
                          @click="togglePasswordOld"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  label-for="new-password"
                  :label="$t('myAccount.fields.newPassword')"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('myAccount.fields.newPassword')"
                    vid="new-password"
                    rules="required|min:8|password"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="new-password"
                        v-model="newPasswordValue"
                        :type="passwordFieldTypeNew"
                        name="new-password"
                        :placeholder="$t('myAccount.placeholders.newPassword')"
                        :state="errors.length > 0 ? false : null"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIconNew"
                          class="cursor-pointer"
                          @click="togglePasswordNew"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  label-for="account-retype-new-password"
                  :label="$t('myAccount.fields.retypeNewPassword')"
                  class="mb-md-0"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('myAccount.fields.confirmPassword')"
                    rules="required|confirmed:new-password"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="account-retype-new-password"
                        v-model="RetypePassword"
                        :type="passwordFieldTypeRetype"
                        name="retype-password"
                        :placeholder="$t('myAccount.placeholders.newPassword')"
                        :state="errors.length > 0 ? false : null"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIconRetype"
                          class="cursor-pointer"
                          @click="togglePasswordRetype"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <div class="text-right mt-2">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary"
              class="mr-1"
            >
              <feather-icon
                icon="RotateCcwIcon"
                class="mr-50"
              />
              {{ $t('myAccount.actions.reset') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click.prevent="onSubmitForm"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-50"
              />
              {{ $t('myAccount.actions.saveChanges') }}
            </b-button>
          </div>
        </b-form>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {} from '@validations'
import helper from '@/service/helper'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      passwordValueOld: '',
      newPasswordValue: '',
      RetypePassword: '',
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    onSubmitForm() {
      this.$refs.simpleRules.validate()
        .then(async success => {
          if (success) {
            const formSender = {
              username: (await this.$store.dispatch('app/LOAD_USER_DATA'))?.username,
              OldPassword: this.passwordValueOld,
              NewPassword: this.newPasswordValue,
            }
            const res = await helper.putAuthen('agent/profile/password', formSender)
            if (res.status === 200) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('myAccount.messages.success'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: res.data,
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('myAccount.messages.error'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: res.data,
                },
              })
            }
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 767px) {
  .card-body {
    padding: 1rem;
  }
}

@media (min-width: 992px) {
  .my-account-password {
    width: 50%;
  }
}
</style>
